import { useDomainInfo, useDomainStatus } from '#entities/domain';
import { useIsOnboardingCompleted } from '#shared/api/onboarding';

export const useIsSitePublished = ({ skip = false }: { skip?: boolean } = {}): boolean => {
    const { data: domainInfo } = useDomainInfo(undefined, { skip });
    const domain = domainInfo?.domain;
    const { currentData: domainStatus } = useDomainStatus({ domain: domain || '' }, { skip: skip || !domain });
    const isOnboardingCompleted = useIsOnboardingCompleted({ skip });

    return !skip && domainInfo?.is_tmp === false && domainStatus?.status === 'SUCCESS' && isOnboardingCompleted;
};
